import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Hashtag20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.24429 2.09304C8.29566 1.68203 8.00412 1.30719 7.59311 1.25581C7.18209 1.20443 6.80725 1.49598 6.75587 1.90699L6.33799 5.25H3C2.58579 5.25 2.25 5.58579 2.25 6C2.25 6.41421 2.58579 6.75 3 6.75H6.15049L5.33799 13.25H2C1.58579 13.25 1.25 13.5858 1.25 14C1.25 14.4142 1.58579 14.75 2 14.75H5.15049L4.75587 17.907C4.70449 18.318 4.99604 18.6929 5.40705 18.7442C5.81807 18.7956 6.19291 18.5041 6.24429 18.093L6.66217 14.75H12.1505L11.7559 17.907C11.7045 18.318 11.996 18.6929 12.4071 18.7442C12.8181 18.7956 13.1929 18.5041 13.2443 18.093L13.6622 14.75H17C17.4142 14.75 17.75 14.4142 17.75 14C17.75 13.5858 17.4142 13.25 17 13.25H13.8497L14.6622 6.75H18C18.4142 6.75 18.75 6.41421 18.75 6C18.75 5.58579 18.4142 5.25 18 5.25H14.8497L15.2443 2.09304C15.2957 1.68203 15.0041 1.30719 14.5931 1.25581C14.1821 1.20443 13.8072 1.49598 13.7559 1.90699L13.338 5.25H7.84967L8.24429 2.09304ZM13.1505 6.75H7.66217L6.84967 13.25H12.338L13.1505 6.75Z'
      fill='currentColor'
    />
  </Svg>
);

Hashtag20.displayName = 'Hashtag20';
export default Hashtag20;
